
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.5 2c0-.792.708-1.5 1.667-1.5h1.416a3.5 3.5 0 013.5 3.5c0 .866.747 1.5 1.584 1.5A3.833 3.833 0 0112.5 9.333V14c0 .79-.71 1.5-1.667 1.5H2.167C1.207 15.5.5 14.79.5 14V2zm9.385 1.5a.718.718 0 110-1.436.718.718 0 010 1.436z","fill":"#fff"}})])
          )
        }
      }
    